import { Outlet, createFileRoute } from "@tanstack/react-router";

import { PERMISSIONS } from "@/constants/permissions";
import { APP_ROUTES_TO } from "@/utils/routes";

export const Route = createFileRoute(APP_ROUTES_TO.PERMISSION_GROUPS)({
  component: PermissionGroupsLayout,
  staticData: {
    config: {
      breadcrumb: {
        title: "permission_groups",
        to: APP_ROUTES_TO.PERMISSION_GROUPS,
      },
      title: "permission_groups",
      layout: { scroll: false },
    },
    permissions: [PERMISSIONS.AUTH_SVC_PERMISSIONS_GROUPS_LIST],
  },
});

function PermissionGroupsLayout() {
  return <Outlet />;
}
